import {
  Box,
  Button,
  Paper,
  Typography,
  Grid,
  Divider,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAuth } from "../../../Context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import LeadNavtabs from "./LeadNavtabs";
import axios from "axios";
const LeadFeatures = () => {
  const apiUrl = process.env.REACT_APP_API_REST_URL;
  const roleId = sessionStorage.getItem("roleId");
  const userId = sessionStorage.getItem("userId");
  const navigate = useNavigate();
  const location = useLocation();
  const [leadData, setLeadData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const leadId = location.state?.leadId || location.state?.leadData?.id;
  // const leadData = location.state?.leadData;
  const [annualincometypes, setannualincometypes] = useState([]);
  console.log(leadData, "leadDatasda");
  const from = location.state?.from || "/employeedashboard/leads";
  const handleMenuClick = (action) => {
    // Handle different actions based on which menu item was clicked
    switch (action) {
      case "profile":
        navigate("/employeedashboard/leads/edit", { state: { leadId, from } });
        break;
      case "interactions":
        navigate("/employeedashboard/leads/interactions", {
          state: { leadId, from },
        });
        break;
      case "add-interaction":
        navigate("/employeedashboard/leads/add-interaction", {
          state: { leadId, from },
        });
        break;
      case "kyc":
        navigate("/employeedashboard/leads/kyc", {
          state: { leadId, from },
        });
        break;
      case "documents":
        console.log("Upload Documents clicked");
        break;
      default:
        break;
    }
  };
  const formatDateTime = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      return (
        date.toLocaleDateString("en-GB") +
        " " +
        date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      );
    } else {
      return "-";
    }
  };
  const formatDate = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB");
    } else {
      return "-";
    }
  };
  const getAnnualincomeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/estimated_annual_income`;
      const response = await axios.get(url, {});
      console.log("waelthndata", response);
      setannualincometypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getAnnualincomeData();
  }, []);
  useEffect(() => {
    const fetchLeadData = async () => {
      if (!leadId) {
        setIsLoading(false);
        setError("No lead ID provided");
        return;
      }

      try {
        setIsLoading(true);
        const response = await axios.get(
          `${apiUrl}/CCE/api/v1/referalEngine/getReferralById/${leadId}`
        );
        setLeadData(response.data);
      } catch (err) {
        console.error("Error fetching lead data:", err);
        setError("Failed to load lead data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchLeadData();
  }, [leadId, apiUrl]);
  const interactions = leadData?.interactionDetails || [];
  const latestInteraction = interactions.reduce(
    (latest, current) =>
      new Date(current.created_date) > new Date(latest.created_date)
        ? current
        : latest,
    interactions[0]
  );
  const allComments =
    interactions.length > 0
      ? interactions
          .map((item) => item.comment)
          .filter(Boolean)
          .join(", ")
      : "-";
  const displayedComments =
    allComments.length > 150
      ? `${allComments.substring(0, 150)}...`
      : allComments;
  return (
    <Box sx={styles.main_container}>
      <Paper sx={styles.dashboard_paper}>
        <LeadNavtabs
          handleMenuClick={handleMenuClick}
          options={[
            {
              label: "Edit Profile",
              onClick: () => handleMenuClick("profile"),
            },
            {
              label: "View Interactions",
              onClick: () => handleMenuClick("interactions"),
            },
            {
              label: "Add Interaction",
              onClick: () => handleMenuClick("add-interaction"),
            },
            { label: "View KYC", onClick: () => handleMenuClick("kyc") },
            {
              label: "Upload Documents",
              onClick: () => handleMenuClick("documents"),
              disabled: true,
            },
          ]}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            p: 1,
            justifyContent: "flex-end",
            width: "50%",
            marginLeft: "auto",
          }}
        >
          <Button
            sx={styles.btn}
            variant="contained"
            onClick={() => navigate(from)}
          >
            Back
          </Button>
        </Box>
      </Paper>
      <Paper
        elevation={3}
        sx={{
          margin: "10px 20px 20px 20px",
          height: "590px",
          borderRadius: "12px",
        }}
      >
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box sx={{ padding: 2 }}>
            <Typography color="error">{error}</Typography>
          </Box>
        ) : leadData ? (
          <Box sx={{ mt: 1 }}>
            <Grid container spacing={1}>
              {/* Left Column */}
              <Grid
                item
                xs={12}
                align={"left"}
                marginLeft={10}
                marginTop={3}
                marginBottom={1}
              >
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                  {leadData.firstname}{" "}
                  {leadData.middlename ? leadData.middlename + " " : ""}
                  {leadData.lastname}
                  <span style={{ fontSize: "13px", marginLeft: "5px" }}>
                    {leadData.ian && `(${leadData.ian})`}
                  </span>
                </Typography>
                <Typography variant="body1" color="text.secondary" gutterBottom>
                  {leadData.email
                    ? `${leadData.email}, ${leadData.phone}`
                    : leadData.phone}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Grid container spacing={1}>
                  {/* Name */}

                  <Grid item xs={5}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      KYC:
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography
                      sx={styles.viewField}
                      align={"left"}
                      //   marginLeft={10}
                      variant="body2"
                      color={
                        leadData.kycStatus === "Pending"
                          ? "red"
                          : leadData.kycStatus === "Incomplete"
                          ? "orange"
                          : leadData.kycStatus === "Completed"
                          ? "green"
                          : "black"
                      }
                    >
                      {leadData.kycStatus}
                    </Typography>
                  </Grid>

                  <Grid item xs={5}>
                    <Typography
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                      sx={styles.viewField}
                    >
                      RRP Name:
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {leadData.leadReferredBy || "-"}
                    </Typography>
                  </Grid>

                  <Grid item xs={5}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      Automobile Owned:
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {leadData.automobileOwned || "-"}
                    </Typography>
                  </Grid>

                  <Grid item xs={5}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      Club Membership:
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {leadData.clubMembership || "-"}
                    </Typography>
                  </Grid>

                  {/* <Grid item xs={5}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      Good About Referral:
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {leadData.description || "-"}
                    </Typography>
                  </Grid> */}

                  <Grid item xs={12} sx={{ my: 1 }}>
                    <Divider />
                  </Grid>
                  <Grid item xs={5}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      Address 1:
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {leadData.address.address1 || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      Address 2:
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {leadData.address.address2 || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      City:
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {leadData.address.city || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      State:
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {leadData.address.state || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      Pincode:
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {leadData.address.pincode || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sx={{ my: 1 }}>
                    <Divider />
                  </Grid>
                  <Grid item xs={5}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      Wealth Advisor:
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {leadData.managerName || "-"}
                    </Typography>
                  </Grid>

                  <Grid item xs={5}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      First Contact Date:
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {formatDate(leadData.firstContactDate) || "-"}
                    </Typography>
                  </Grid>

                  <Grid item xs={5}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      Comments:
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {leadData.comments || "-"}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              {/* Right Column */}
              <Grid item xs={12} md={6}>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      Status:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      align={"left"}
                      variant="body2"
                      color={
                        latestInteraction?.lead_status_desc?.includes("Hot")
                          ? "green"
                          : latestInteraction?.lead_status_desc?.includes(
                              "Warm"
                            )
                          ? "orange"
                          : latestInteraction?.lead_status_desc?.includes(
                              "Cold"
                            )
                          ? "red"
                          : "black"
                      }
                    >
                      {latestInteraction?.status_desc || "-"},{" "}
                      {latestInteraction?.lead_status_desc || "-"}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      Expected Date of Closure:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {formatDate(
                        latestInteraction?.expected_date_of_closure
                      ) || "-"}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      Estimated Portfolio Value:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {latestInteraction?.estimated_portfolio_value || "-"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sx={{ my: 1 }}>
                    <Divider />
                  </Grid>

                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      Last Contact Date:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {formatDate(latestInteraction?.meeting_at) || "-"}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      Engagement Type:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {latestInteraction?.engagement_type_description || "-"},
                      {latestInteraction?.location_type_description || "-"},
                      {latestInteraction?.location || "-"}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      Discussion Brief:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {latestInteraction?.discussion_brief || "-"}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      Wealth Product Discussed:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {latestInteraction?.wealth_product_discussed_descriptions?.join(
                        ", "
                      ) || "-"}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      Other Business Opportunity:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {latestInteraction?.other_business_opportunity_descriptions?.join(
                        ", "
                      ) || "-"}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      Estimated Annual Income:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {annualincometypes.find(
                        (item) =>
                          item.id === latestInteraction?.estimated_annual_income
                      )?.masterValueDesc || "-"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sx={{ my: 1 }}>
                    <Divider />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      Follow Up:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {formatDateTime(latestInteraction?.followup_date_n_time)},
                      {latestInteraction?.followup_type_description || "-"},
                      {latestInteraction?.followup_location_type_description ||
                        "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={styles.viewField}
                      variant="body2"
                      fontWeight="bold"
                      align={"left"}
                      marginLeft={10}
                    >
                      Comment:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      title={allComments}
                      sx={styles.viewField}
                      variant="body2"
                      align={"left"}
                    >
                      {displayedComments}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <Box sx={{ padding: 2 }}>
            <Typography>No lead data available</Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default LeadFeatures;
const styles = {
  main_container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "90vh",
    padding: "0px",
    margin: "0px",
    marginTop: "-25px",
    background: "#f2f2f2",
  },
  dashboard_paper: {
    height: "40px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
    margin: "0px 20px",
  },
  btn: {
    width: "80px",
    fontSize: "11px",
    marginTop: "3px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  textfield: {
    width: "340px",
  },
  viewField: {
    fontSize: "13px",
  },
};
